import { Stage } from "@/types/productTypes";
import { ControlHover } from "../MainEditorPanel";
import OptionVisualizer from "./OptionVIsualizer";
import { cn } from "@/lib/utils";

type StageVisualizerProps = {
   stage: Stage | null;
   productTitle: string | undefined;
   controlHovered: ControlHover | null;
   setControlHovered: React.Dispatch<React.SetStateAction<ControlHover | null>>;
};

export default function StageVisualizer({
   stage,
   productTitle,
   controlHovered,
   setControlHovered,
}: StageVisualizerProps) {
   if (!stage) {
      return null;
   }

   const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!stage.id) return;
      if (e.ctrlKey) {
         setControlHovered({
            type: "Stage",
            stageId: stage.id,
            optionId: null,
            itemId: null,
         });
      }
   };

   const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!stage.id) return;
      e.stopPropagation();
      // Update hover state dynamically while the mouse moves within the element
      if (e.ctrlKey) {
         setControlHovered({
            type: "Stage",
            stageId: stage.id,
            optionId: null,
            itemId: null,
         });
      } else {
         setControlHovered(null);
      }
   };

   const handleMouseLeave = () => {
      setControlHovered(null);
   };

   return (
      <div
         onMouseEnter={handleMouseEnter}
         onMouseMove={handleMouseMove}
         onMouseLeave={handleMouseLeave}
         className={cn(
            "flex flex-col border-2  mx-auto",
            controlHovered?.type === "Stage" &&
               controlHovered.stageId === stage.id
               ? "border-blue-500 border-dashed"
               : "border-white"
         )}
      >
         <h1 className="text-2xl leading-normal uppercase font-bold pt-9">
            {productTitle}
         </h1>
         {stage.header && (
            <h2 className="mb-4 text-xl leading-normal uppercase font-bold">
               {stage.header}
            </h2>
         )}
         <div className="overflow-y-auto custom-scrollbar">
            {stage.options?.map(
               (option, index) =>
                  stage.id && (
                     <OptionVisualizer
                        setControlHovered={setControlHovered}
                        controlHovered={controlHovered}
                        key={index}
                        option={option}
                        stageId={stage.id}
                     />
                  )
            )}
         </div>
      </div>
   );
}
